export default __webpack_public_path__ + "static/media/ic_validacion.26eb7429.svg";